import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { GALLERY, IMAGES } from "../../data";

function ParallaxImg({ src, range, className }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], range);
  return (
    <div ref={ref} className={`overflow-hidden rounded-lg border border-white/10 ${className}`}>
      <motion.img
        style={{ y }}
        src={src}
        alt="War Room Performance"
        className="h-[120%] w-full object-cover -mt-[10%]"
      />
    </div>
  );
}

// Two ranges alternate for a subtle staggered parallax across the grid.
const RANGES = [
  [60, -60],
  [30, -30],
  [80, -80],
  [45, -45],
  [70, -70],
  [50, -50],
];

export default function Gallery() {
  const items = GALLERY.filter((k) => IMAGES[k]);

  return (
    <section
      id="gallery"
      className="relative bg-[#0C0C0C] py-24 md:py-36 px-6 lg:px-10"
      data-testid="gallery-section"
    >
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <p className="font-body text-xs md:text-sm uppercase tracking-[0.3em] text-teal mb-6">
            / Inside The Room
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-700 uppercase leading-[0.9] tracking-tighter text-white text-5xl md:text-6xl lg:text-7xl mb-16">
            The gallery
          </h2>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((key, i) => (
            <ParallaxImg
              key={key}
              src={IMAGES[key]}
              range={RANGES[i % RANGES.length]}
              className="aspect-[3/4]"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
